var render = function () {
  var _vm$detail, _vm$detail$orderRefun;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "company-applyment-module"
  }, [_c('el-affix', {
    class: {
      'applyment-page-header-top': _vm.affixed,
      'applyment-page-header-shrink': _vm.sidebarFold,
      'applyment-page-header-unfold': !_vm.sidebarFold
    },
    attrs: {
      "offset": 80
    },
    on: {
      "change": _vm.handleAffixChange
    }
  }, [_c('el-card', [_c('div', {
    staticClass: "applyment-page-header"
  }, [_c('div', {
    staticClass: "status"
  }, [_vm._v(" " + _vm._s(_vm.orderStatusFormat(_vm.detail.status)) + " "), _vm.detail.creditStatus ? _c('span', {
    staticClass: "fs12"
  }, [_vm._v("(Credit: " + _vm._s(_vm.creditStatusFormat(_vm.detail.creditStatus)) + ")")]) : _vm._e()]), _c('div', {
    staticClass: "page-header-heading-right"
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "icon": "el-icon-tickets"
    },
    on: {
      "click": _vm.openCreditHistoryModal
    }
  }, [_vm._v("Credit History")]), _c('div', {
    staticClass: "ml10 opts"
  }, [(_vm.detail.status === 'UNPAID' || _vm.detail.status === 'PARTLY_PAID') && _vm.isAuth('finance:financial') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.handleConfirmReceipt
    }
  }, [_vm._v(" Confirm Receipt ")]) : _vm._e()], 1), _vm.detail.status === 'UNPAID' || _vm.detail.status === 'PARTLY_PAID' ? _c('div', {
    staticClass: "ml10 opts"
  }, [(!_vm.detail.creditStatus || _vm.detail.creditStatus == 'REJECTED') && _vm.isAuth('finance:creditApply') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.handleCreditApply
    }
  }, [_vm._v(" " + _vm._s(_vm.detail.creditStatus == "REJECTED" ? "Credit Re-apply" : "Credit Apply") + " ")]) : _vm._e(), _vm.detail.creditStatus == 'PENDING' && _vm.isAuth('finance:audit') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.handleCreditReview
    }
  }, [_vm._v(" Credit Review ")]) : _vm._e(), _vm.detail.creditStatus == 'PASSED' && _vm.isAuth('finance:financial') ? _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "medium"
    },
    on: {
      "click": _vm.handleForfeitOrder
    }
  }, [_vm._v(" Forfeit Order ")]) : _vm._e()], 1) : _vm._e()], 1)])])], 1), _c('div', {
    staticClass: "step mt20"
  }, [_c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('base-info', {
    attrs: {
      "detail": _vm.detail
    }
  })], 1)], 1), ((_vm$detail = _vm.detail) === null || _vm$detail === void 0 ? void 0 : (_vm$detail$orderRefun = _vm$detail.orderRefundList) === null || _vm$detail$orderRefun === void 0 ? void 0 : _vm$detail$orderRefun.length) > 0 ? _c('div', {
    staticClass: "step mt20"
  }, [_c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('linked-refund-order-list', {
    attrs: {
      "detail": _vm.detail
    }
  })], 1)], 1) : _vm._e(), _c('confirm-receipt', {
    ref: "confirmReceiptModal",
    attrs: {
      "invoice": _vm.detail.invoice
    }
  }), _c('credit-apply', {
    ref: "creditApplyModal"
  }), _c('credit-review', {
    ref: "creditReviewModal"
  }), _c('credit-history', {
    ref: "creditHistoryModal",
    attrs: {
      "orderId": _vm.detail.id
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }